var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.975 1.75C2.57459 1.75 2.25 2.07459 2.25 2.475C2.25 2.87541 2.57459 3.2 2.975 3.2V2.475L2.97501 3.2H2.97504H2.97515H2.97562H2.97744H2.98046H2.98465H2.99641H3.01252H3.1166H3.47344H3.79025L4.43136 8.00832L4.43343 8.02274L4.76273 10.1632L3.76673 12.3212C3.66312 12.5457 3.68105 12.8075 3.81431 13.0157C3.94756 13.224 4.17776 13.35 4.425 13.35H7.325C6.52419 13.35 5.875 13.9992 5.875 14.8C5.875 15.6008 6.52419 16.25 7.325 16.25C8.12581 16.25 8.775 15.6008 8.775 14.8C8.775 13.9992 8.12581 13.35 7.325 13.35H12.4C11.5992 13.35 10.95 13.9992 10.95 14.8C10.95 15.6008 11.5992 16.25 12.4 16.25C13.2008 16.25 13.85 15.6008 13.85 14.8C13.85 13.9992 13.2008 13.35 12.4 13.35H14.2125C14.6129 13.35 14.9375 13.0254 14.9375 12.625C14.9375 12.2246 14.6129 11.9 14.2125 11.9H5.55811L5.89272 11.175H13.85C14.1621 11.175 14.4391 10.9753 14.5378 10.6793L16.7128 4.15427C16.7865 3.93318 16.7494 3.69014 16.6132 3.50109C16.4769 3.31203 16.258 3.2 16.025 3.2H5.25308L5.14364 2.37918C5.09562 2.019 4.78837 1.75 4.425 1.75H3.47344H3.1166H3.01252H2.98465H2.97744H2.97638H2.97596H2.97578H2.97562H2.97535H2.97524H2.97515H2.97504H2.97501L2.975 2.475V1.75ZM5.44642 4.65L5.86768 7.80946L6.16238 9.725H13.3275L15.0191 4.65H5.44642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cart-white.7a08c2ee32987cf8b74141827f2dc551.svg";
export { ForwardRef as ReactComponent };